
import React, { useState } from 'react';
import { Row } from 'react-bootstrap';
import Image from 'react-bootstrap/Image'


function Photo(props) {
  
  return (
    <>
    
    
        <Image src={props.source} thumbnail={true} style={{width:"80px", height:"50px", margin:"18px", marginRight:"auto"}} onClick={props.click} />
    
    </>
  );
}

export default Photo;
